export const handleConvertBenhNhanInfo = (data: any): any => {
    return {
        patient: {
            personName: data?.patientName,
            code: data?.patientCode,
            dobDay: data?.dobDay,
            dobMonth: data?.dobMonth,
            dobYear: data?.dobYear,
            gender: data?.gender,
            contact: data?.contact,
        },
        visit: {
            ...data,
        }
    }
};